import { BodyMedium, ChevronDownIcon, ChevronUpIcon, TeamIcon } from '@arnold/common';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoItem, RootTeamsExpand, RootTeamsText, RootTeamsToggle, RootTeamsValue } from '../../newReportPageStyles';

interface RootTeamsSummaryProps {
  names: string[];
}

export const RootTeamsSummary = ({ names }: RootTeamsSummaryProps) => {
  const { t } = useTranslation('newReport');
  const [showAll, setShowAll] = useState(false);

  return (
    <InfoItem>
      <TeamIcon />
      <BodyMedium>
        <RootTeamsValue>
          <RootTeamsText>{names.slice(0, showAll ? names.length : 3).join(', ')}</RootTeamsText>
          {names.length > 3 && (
            <RootTeamsExpand>
              {!showAll && '…'}
              <RootTeamsToggle
                type="button"
                onClick={() => setShowAll((isShown) => !isShown)}
                aria-expanded={showAll}
                aria-label={showAll ? t('collapseAll') : t('expandAll')}
              >
                {showAll ? <ChevronUpIcon /> : <ChevronDownIcon />}
              </RootTeamsToggle>
            </RootTeamsExpand>
          )}
        </RootTeamsValue>
      </BodyMedium>
    </InfoItem>
  );
};
